import { useState } from "react";
import { Menu, X, Search } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    document.body.style.overflow = isOpen ? "auto" : "hidden";
  };

  return (
    <nav className="bg-[#121212] shadow-md fixed top-0 left-0 w-full z-50 h-16 flex items-center px-4 md:px-8 border-b border-[#00F0FF]">
      <div className="w-full max-w-7xl mx-auto flex justify-between items-center">
        {/* Left side - Logo */}
        <div className="flex items-center space-x-4">
          <a
            href="#"
            onClick={() => navigate("/")}
            className="text-xl md:text-2xl font-bold text-[#00F0FF] cursor-pointer transition-colors hover:text-[#FF007F]"
          >
            Browserarena
          </a>
        </div>

        {/* Right side - Desktop menu */}
        <div className="hidden md:flex items-center space-x-6">
          <button
            onClick={() => navigate("/search")}
            className="text-[#00F0FF] hover:text-[#FF007F] transition"
            aria-label="Search"
          >
            <Search size={22} />
          </button>
          <button
            onClick={() => navigate("/")}
            className="hover:text-[#FF007F] transition cursor-pointer"
          >
            Home
          </button>
          <button
            onClick={() => navigate("/categories")}
            className="hover:text-[#FF007F] transition cursor-pointer"
          >
            Categories
          </button>
          <button
            onClick={() => navigate("/about")}
            className="hover:text-[#FF007F] transition cursor-pointer"
          >
            About
          </button>
        </div>

        {/* Mobile Menu Button */}
        <div className="flex md:hidden items-center">
          <button onClick={toggleMenu} className="text-[#00F0FF]" aria-label="Toggle Menu">
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>

      {/* Mobile Dropdown Menu */}
      {isOpen && (
        <div className="absolute top-16 left-0 w-full bg-[#1a1a2e] border-t border-[#00F0FF] shadow-md">
          <ul className="flex flex-col p-4 space-y-4 text-[#00F0FF]">
            <li>
              <button
                onClick={() => {
                  navigate("/search");
                  toggleMenu();
                }}
                className="flex items-center hover:text-[#FF007F] transition w-full text-left"
              >
                🔎 Search
              </button>
            </li>
            <li>
              <button
                onClick={() => {
                  navigate("/");
                  toggleMenu();
                }}
                className="flex items-center hover:text-[#FF007F] transition w-full text-left"
              >
                🏠 Home
              </button>
            </li>
            <li>
              <button
                onClick={() => {
                  navigate("/categories");
                  toggleMenu();
                }}
                className="flex items-center hover:text-[#FF007F] transition w-full text-left"
              >
                🗂️ Categories
              </button>
            </li>
            <li>
              <button
                onClick={() => {
                  navigate("/about");
                  toggleMenu();
                }}
                className="flex items-center hover:text-[#FF007F] transition w-full text-left"
              >
                ℹ️ About
              </button>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
}
